import React, { FC } from 'react';
import { CloseButton, HelpLink, Text, WixIcons } from '..';
import styles from './ModalHeader.scss';
import { IInner, IOuter } from './ModalHeader.types';

export const ModalHeader: FC<IOuter & IInner> = ({ title, helpArticle }) => (
  <>
    <Text className={styles.title} weight="normal" size="medium">
      {title}
    </Text>

    {helpArticle && (
      <HelpLink Component={CloseButton} article={helpArticle} skin="lightFilled" size="medium">
        <WixIcons.HelpSmall />
      </HelpLink>
    )}
  </>
);
